import DamageTypePage from "@/components/damageType/DamageTypePage";

const RansomwareSchutz = () => <DamageTypePage slug="ransomware-schutz" />;
export default RansomwareSchutz;
